import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';

import * as PageSettingStore from '../../../app/store/PageSettingStore';

import { TaskContent } from '../../../youwell-common/components';
import urls from '../../../app/urls';
import { isBrowser } from '../../../youwell-common/browserUtils';
import { parseInternalLink } from '../../../youwell-common/taskContentUtils';
import { getContentTranslations } from '../../../common/components/VimoTaskContent';

export const styles = theme => ({
    root: {
    },
    htmlContent: {
        color: theme.colors.blue4,
    },
    taskTitle: {
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(4),
    },
});


class PublicTaskContent extends React.Component {
    componentDidMount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__clickInternalLink = this.clickInternalLink;
        }
    }

    componentWillUnmount() {
        if (isBrowser) {
            // eslint-disable-next-line no-underscore-dangle
            window.__clickInternalLink = null;
        }
    }

    clickInternalLink = (elementId) => {
        const url = this.getLinkUrl({ url: elementId });
        this.props.redirect(url);
    }

    getLinkUrl = (link) => {
        const { taskOrModuleId, hash } = parseInternalLink(link);
        return `${urls.page}/${taskOrModuleId}${hash}`;
    }

    getProgramItem = id => (this.props.allContent ? this.props.allContent[id] : null)

    render() {
        const {
            classes, translate, task, showTitle,
        } = this.props;

        if (!task) {
            return null;
        }

        return (
            <TaskContent
                className={classnames(classes.root)}
                showTitle={showTitle}
                TaskElementProps={{
                    classes: {
                        htmlContent: classes.htmlContent,
                        title: classes.taskTitle,
                    },
                }}
                LinkElementProps={{
                    getLinkUrl: this.getLinkUrl,
                }}
                task={task}
                getProgramItem={this.getProgramItem}
                translations={getContentTranslations(translate)}
                getSpecificTaskResponses={() => {}}
                onSaveChanges={() => {}}
                onResponse={() => {}}
            />
        );
    }
}

PublicTaskContent.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired,
    task: PropTypes.object,
    allContent: PropTypes.object,
    showTitle: PropTypes.bool,
};

PublicTaskContent.defaultProps = {
    task: null,
    showTitle: false,
    allContent: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    allContent: state.program.content,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PageSettingStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PublicTaskContent));
